/**
 * Redux DevTools configuration for Vite
 */

export const devToolsConfig = {
  name: 'EFU Life App',
  trace: true,
  traceLimit: 25,
  actionCreators: {
    // Add action creators for easier debugging
  },
  features: {
    persist: true,
    lock: true,
    pause: true,
    export: true,
    import: 'custom',
    jump: true,
    skip: true,
    reorder: true,
    dispatch: true,
    test: true,
  },
  actionSanitizer: (action) => {
    // Sanitize sensitive data in development
    if (action.type.includes('auth/login') || action.type.includes('auth/register')) {
      return {
        ...action,
        payload: {
          ...action.payload,
          password: '[REDACTED]',
          confirmPassword: '[REDACTED]',
        }
      };
    }
    return action;
  },
  stateSanitizer: (state) => {
    // Sanitize sensitive data in state
    if (state.auth && state.auth.user) {
      return {
        ...state,
        auth: {
          ...state.auth,
          user: {
            ...state.auth.user,
            // Hide sensitive user data in DevTools
            password: '[REDACTED]',
          }
        }
      };
    }
    return state;
  },
};